var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarDevelopper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92596 14.6693C5.24405 14.6693 2.25928 11.6845 2.25928 8.00258C2.25928 4.3207 5.24405 1.33594 8.92596 1.33594C12.6078 1.33594 15.5926 4.3207 15.5926 8.00258C15.5926 11.6845 12.6078 14.6693 8.92596 14.6693ZM8.92596 13.3359C11.8715 13.3359 14.2593 10.9481 14.2593 8.00258C14.2593 5.05708 11.8715 2.66927 8.92596 2.66927C5.98042 2.66927 3.59261 5.05708 3.59261 8.00258C3.59261 10.9481 5.98042 13.3359 8.92596 13.3359ZM6.59261 9.33592H10.2593C10.4434 9.33592 10.5926 9.18672 10.5926 9.00258C10.5926 8.81852 10.4434 8.66925 10.2593 8.66925H7.59262C6.67214 8.66925 5.92594 7.92305 5.92594 7.00258C5.92594 6.08213 6.67214 5.33594 7.59262 5.33594H8.25929V4.0026H9.59262V5.33594H11.2593V6.66925H7.59262C7.40852 6.66925 7.25928 6.81852 7.25928 7.00258C7.25928 7.18672 7.40852 7.33592 7.59262 7.33592H10.2593C11.1798 7.33592 11.926 8.08212 11.926 9.00258C11.926 9.92305 11.1798 10.6693 10.2593 10.6693H9.59262V12.0026H8.25929V10.6693H6.59261V9.33592Z",
    fill: "#E65425"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarDevelopper);
export default __webpack_public_path__ + "static/media/dollar-developper.e4ab503c8dfc569cd1210d4ee98c2b01.svg";
export { ForwardRef as ReactComponent };